import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { EXHIBIT_TYPE as EXHIBITTYPE } from "./../../../../../../utils/constant.utils";
import { createRequestActions } from "./../../../../../../store/external/request-reducer/create-request.reducer";
import NewCircuitFormA from "./exhibit-a/new-circuit-form.component";
import NewCircuitFormB from "./exhibit-b/new-circuit-form-ex-b.component";

class NewCircuitForm extends Component {

    constructor(props) {
        super(props);
    }

    async componentDidMount() {

        await this.props.getExhibitType();
    }

    displayForm = () => {

        const { modalMessage, modalClose, disableROBCheckbox } = this.props;
        const { exhibitType } = this.props.createRequest;
        let form;

        // if (exhibitType == EXHIBITTYPE.exhibitA) {
        //     form = <NewCircuitFormA modalMessage={modalMessage} modalClose={modalClose} disableROBCheckbox={disableROBCheckbox} />
        // } else if (exhibitType == EXHIBITTYPE.exhibitB) {
        //     form = <NewCircuitFormB modalMessage={modalMessage} modalClose={modalClose} disableROBCheckbox={disableROBCheckbox}/>
        // } else {
        //     form = null;
        // }

        form = <NewCircuitFormA hideRequestModal={this.props.hideRequestModal} modalMessage={modalMessage} modalClose={modalClose} disableROBCheckbox={disableROBCheckbox} />

        return (form);
    }

    render() {
        return (
            <div>
                {this.displayForm()}
            </div>
        );
    }
};
export default connect(
    state => {
        const { createRequest } = state;
        return {
            createRequest
        };
    }
    , dispatch =>
        bindActionCreators(
            Object.assign({}, createRequestActions),
            dispatch
        )
)(NewCircuitForm);